import { logger } from '@fe/core';
import { addNotification, NotificationType } from '../app/state/slices/global-slice';
import { store } from '../app/state/store';
import { FeedbackApiService } from './axios/axios-api-generated';

export async function sendEmailAlerts(email: string, subject: string, content: string) {
    try {
        const response = await FeedbackApiService.feWebAlert(
            {
                body: {
                    nameOfSender: 'Flight Explorer Alerts',
                    toEmails: [email],
                    alertHtmlContent: content,
                    alertSubject: subject
                }
            },
            {
                withAuthorization: true
            }
        );

        const code = response.responseCode as EmailAlertError;
        if (code === EmailAlertError.none) {
            return;
        }

        if (code === EmailAlertError.sendFailed) {
            store.dispatch(addNotification({ type: NotificationType.emailAlertSendFail }));
        } else if (code === EmailAlertError.tooManyRequestsPerHour || code === EmailAlertError.tooManyRequestsPerMinute) {
            store.dispatch(addNotification({ type: NotificationType.emailAlertTooManyRequest }));
        } else {
            store.dispatch(addNotification({ type: NotificationType.emailAlertGeneralError }));
        }
    } catch (err) {
        logger.trackException(err);
    }
}

enum EmailAlertError {
    none,
    sendFailed,
    noEmailAddress,
    tooManyRequestsPerMinute,
    tooManyRequestsPerHour,
    otherError
}
